import { render, staticRenderFns } from "./ProductsFormPage.vue?vue&type=template&id=0a202092&scoped=true&"
import script from "./ProductsFormPage.vue?vue&type=script&lang=js&"
export * from "./ProductsFormPage.vue?vue&type=script&lang=js&"
import style0 from "./ProductsFormPage.vue?vue&type=style&index=0&id=0a202092&prod&scoped=true&lang=css&"
import style1 from "./ProductsFormPage.vue?vue&type=style&index=1&id=0a202092&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a202092",
  null
  
)

export default component.exports